// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__9z9qI","title":"ClientInsurance_title__3bMpJ","itemText":"ClientInsurance_itemText__1ss0r"};